import { KeycloakEvent, KeycloakService } from 'keycloak-angular';
import { Subject } from 'rxjs';

export default {
  getKeycloakInstance: () => {
    return {
      createLoginUrl: () => 'https://test.local/login',
      createRegisterUrl: () => 'https://test.local/registraton',
      createLogoutUrl: () => 'https://test.local/logout',
    };
  },
  getUserRoles: (_realmRoles?: boolean, _resource?: string) => [],
  isLoggedIn: () => false,
  init: () => new Promise<boolean>(() => true),
  keycloakEvents$: new Subject<KeycloakEvent>(),
} as unknown as KeycloakService;
